import { render, staticRenderFns } from "./DealDetails.vue?vue&type=template&id=1ba84abf&"
import script from "./DealDetails.vue?vue&type=script&lang=js&"
export * from "./DealDetails.vue?vue&type=script&lang=js&"
import style0 from "./DealDetails.vue?vue&type=style&index=0&id=1ba84abf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports